var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Comodidades","storeName":"Amenities","labelAddNew":"Añadir nueva comodidad","canAdd":true,"canEdit":true,"canDelete":true,"sortable":"","next-link":"/admin/provinces","breadcrumbs":[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/amenities'
      },
      {
        text: 'Comodidades',
        disabled: false,
        href: '#'
      }
    ]},scopedSlots:_vm._u([{key:"icon_picture",fn:function({ item }){return [_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[(item.icon_picture)?_c('v-list-item-avatar',[_c('img',{attrs:{"src":item.icon_picture,"alt":""}})]):_vm._e()],1)],1)]}},{key:"description",fn:function({ item }){return [_c('div',{staticClass:"table-cell-fixed description-cell"},[_vm._v(" "+_vm._s(item.description)+" ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }